import { gql } from '@apollo/client';

export const getAttributeLevelSales = gql`
    query getGrowthAnalysisData(
        $timePeriod: JSONString!
        $aggPeriod: String!
        $dimension: SamyaString!
        $attributeType: SamyaString!
        $filters: JSONString!
        $lagList: [Int]!
        $limit: Int
        $offset: Int!
        $metricType: SamyaString
    ) {
        getGrowthAnalysisData(
            timePeriod: $timePeriod
            aggPeriod: $aggPeriod
            dimension: $dimension
            attributeType: $attributeType
            filters: $filters
            lagList: $lagList
            limit: $limit
            offset: $offset
            metricType: $metricType
        ) {
            data {
                attributeType
                graphData {
                    lag
                    salesData
                    baseData
                    promoData
                    noPromoData
                    incrementalData
                }
                additionalData {
                    sales {
                        labelName
                        value
                    }
                    incremental {
                        labelName
                        value
                    }
                    promo {
                        labelName
                        value
                    }
                }
            }
            meta {
                count
                __typename
            }
        }
    }
`;

export const getTotalSales = gql`
    query getTotalSales($timePeriod: JSONString!, $filters: JSONString!, $lagList: [Int]!) {
        getTotalSales(timePeriod: $timePeriod, filters: $filters, lagList: $lagList) {
            totalSalesData {
                lag
                salesValue
                salesVolume
                promoValue
                noPromoValue
                promoVolume
                noPromoVolume
                baseValue
                baseVolume
                incrementalValue
                incrementalVolume
            }
        }
    }
`;

export const getSalesAttribute = gql`
    query getSalesAttributionFeatureGroupLevel(
        $filter: JSONString
        $aggPeriod: String!
        $timePeriod: JSONString!
        $contributionType: SamyaString
    ) {
        getSalesAttributionFeatureGroupLevel(
            timePeriod: $timePeriod
            aggPeriod: $aggPeriod
            contributionType: $contributionType
            filters: $filter
        ) {
            contributionType
            featureGroupLevelData {
                totalSalesData {
                    lag
                    value
                    label
                }
                featureGroups {
                    groupName
                    groupValue
                }
            }
        }
    }
`;

export const getProfitPoolData = gql`
    query getSalesAttributionProfit($filter: JSONString, $timePeriod: JSONString!, $aggPeriod: String!) {
        getSalesAttributionProfit(timePeriod: $timePeriod, aggPeriod: $aggPeriod, filters: $filter) {
            totalSalesData {
                lag
                value
                label
            }
            featureGroups {
                groupName
                features {
                    featureName
                    value
                }
            }
        }
    }
`;

export const getTrendsChartData = gql`
    query getAttributeTrendChartData(
        $timePeriod: JSONString!
        $attributionField: SamyaString!
        $dimension: SamyaString!
        $attributeType: SamyaString!
        $contributionType: SamyaString!
        $limit: Int!
        $offset: Int!
        $filters: JSONString!
    ) {
        getAttributeTrendChartData(
            timePeriod: $timePeriod
            attributionField: $attributionField
            dimension: $dimension
            attributeType: $attributeType
            contributionType: $contributionType
            limit: $limit
            offset: $offset
            filters: $filters
        ) {
            data {
                attributeName
                startTimestamp
                periodLabel
                attributionValue
                salesCurrent
                salesPrevious
            }
            meta {
                count
            }
        }
    }
`;

export const getSalesAttributionFeatureLevelData = gql`
    query getSalesAttributionFeatureLevel(
        $featureGroupName: SamyaString
        $filter: JSONString
        $aggPeriod: String!
        $timePeriod: JSONString!
        $contributionType: SamyaString
        $lagList: [Int]!
    ) {
        getSalesAttributionFeatureLevel(
            featureGroupName: $featureGroupName
            timePeriod: $timePeriod
            aggPeriod: $aggPeriod
            contributionType: $contributionType
            filters: $filter
            lagList: $lagList
        ) {
            contributionType
            featureGroupName
            featureLevelData {
                featureName
                featureValue
                __typename
            }
            __typename
        }
        __typename
    }
`;

export const getAttributionFeatureDimensionLevel = gql`
    query getSalesAttributionFeatureDimensionLevel(
        $featureGroupName: SamyaString!
        $featureName: SamyaString!
        $dimension: SamyaString!
        $aggPeriod: String!
        $lagList: [Int]!
        $attributeType: SamyaString!
        $filter: JSONString
        $timePeriod: JSONString!
        $contributionType: SamyaString
        $limit: Int
        $offset: Int!
    ) {
        getSalesAttributionFeatureDimensionLevel(
            featureGroupName: $featureGroupName
            featureName: $featureName
            dimension: $dimension
            attributeType: $attributeType
            timePeriod: $timePeriod
            aggPeriod: $aggPeriod
            contributionType: $contributionType
            filters: $filter
            lagList: $lagList
            limit: $limit
            offset: $offset
        ) {
            contributionType
            featureGroupName
            featureName
            attributeType
            featureDimensionLevelData {
                attributeName
                attributeValue
            }
            count
        }
        __typename
    }
`;
